<template>
  <div>
    <div class="login">
      <div class="container">
        <div class="logo">
          <a href="#" class="logo-link">
            <img src="/static/images/torepi-logo.png" alt="" class="mb-4 logo-img">
          </a>
        </div>
        <div class="login-box">
          <div class="title-box">
            <h2 class="pri-title">ログイン</h2>
          </div>
          <form class="login-box--form" @submit.prevent="login">
            <div class="form-group">
              <label for="email" class="label-form">メールアドレス<span class="required">*</span></label>
              <div class="input-group">
                <input type="text" name="" id="email" class="input-form" placeholder="メールを入力してください " v-model.trim="formData.email" :class="emailFormat()" @input="$v.formData.email.$touch()" @change="checkUserCompanyAffiliated">
                <small v-if="!$v.formData.email.required && invalid" class="text-input error">{{message.EMAIL_REQUIRED}}</small>
                <small v-if="!$v.formData.email.valid && invalid && $v.formData.email.required" class="text-input error">{{message.EMAIL_FORMAT}}</small>
              </div>
            </div>
            <div class="form-group">
              <label for="password" class="label-form">パスワード<span class="required">*</span></label>
              <div class="input-group">
                <input type="password" id="password" class="input-form" :class="passwordError()" placeholder="パスワードを入力してください" autocomplete="on" v-model.trim="formData.password" @input="checkUserCompanyAffiliated">
                <small v-if="!$v.formData.password.required && invalid" class="text-input error">{{message.PASSWORD_REQUIRED}}</small>
                <small v-if="passwordErrorFormat()" class="text-input error">{{message.PASSWORD_FORMAT}}</small>
              </div>
            </div>
            <div class="form-group" v-if="errorMessage.passwordOrEmail">
              <div class="input-group">
                <small class="text-input error">{{validateEmail(errorMessage.passwordOrEmail)}}</small>
              </div>
            </div>
            <div v-if="userCompanyIds && userCompanyIds.length > 1" class="form-group">
                <label class="label-form">会社</label>
                <div class="input-group">
                  <b-form-select  class="select select-dropdown input-form" v-model.trim="formData.company_uuid">
                    <b-form-select-option v-for="company in companies" :key="company.id" :value="company.id">{{company.company_name}}</b-form-select-option>
                  </b-form-select>
                </div>
              </div>
            <div class="button-group">
              <button class="btn btn-rounder btn-primary btn-login" @click="login">ログイン</button>
            </div>
            <div class="form-footer text-center">
              <p class="text">アカウントをお持ちでない場合は <a class="link"><router-link :to="{name: 'contact'}">管理者</router-link></a>にご連絡ください。</p>
              <p class="text">パスワードをお忘れの場合は<a href="#" class="link"> <router-link :to="{name: 'reset_password'}">こちら</router-link></a>で再発行してください。</p>
              <p class="text"><a href="#" class="link"> <router-link :to="{name: 'contact'}">お問い合わせ</router-link></a></p>
            </div>
          </form>
        </div>
        <div class="copyright">
          <span>株式会社SOFTNEXT©2020 All rights reserved</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import errorMessage from '../../utils/errormessage'
import {maxLength, minLength, required} from 'vuelidate/lib/validators'
import {MESSAGE} from '../../utils/errorjapanese'
import VueCookies from 'vue-cookies'

export default {
  name: 'login',
  data () {
    return {
      formData: {
        email: '',
        password: ''
      },
      invalid: false,
      message: MESSAGE,
      paginations: {
        sortBy: 'created_at',
        sortOrder: 'desc',
        searchQuery: '',
        typingTimer: null,
        isTyping: false
      }
    }
  },
  validations: {
    formData: {
      email: {
        required,
        valid (email) {
          const validate = /^[[a-zA-Z][a-zA-Z0-9_.-]{1,32}@[a-z0-9_-]{2,}(\.[a-z0-9]{2,}){1,}$/.test(email)
          return validate
        }
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(16),
        valid (password) {
          const containsUppercase = /[A-Z]/.test(password)
          const containsLowercase = /[a-z]/.test(password)
          const containsNumber = /[0-9]/.test(password)
          const containsSpecial = /[#?!@$%^&*-]/.test(password)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        }
      }
    }
  },
  methods: {
    validateEmail (value) {
      return errorMessage.errorEmail(value)
    },
    emailFormat () {
      return (!this.$v.formData.email.valid || !this.$v.formData.email.required) && this.invalid ? 'error' : ''
    },
    passwordError () {
      return (!this.$v.formData.password.required || !this.$v.formData.password.minLength || !this.$v.formData.password.maxLength || !this.$v.formData.password.valid) && this.invalid ? 'error' : ''
    },
    passwordErrorFormat () {
      if (this.formData.password) {
        return (!this.$v.formData.password.minLength || !this.$v.formData.password.maxLength || !this.$v.formData.password.valid) && this.invalid ? 'error' : ''
      }
    },
    login (e) {
      e.preventDefault()
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      this.$store.dispatch('allAuth/login', this.formData)
      setTimeout(() => {
        this.$forceUpdate()
      }, 1000)
    },
    emailError () {
      return this.errorMessage.email
    },
    checkUserCompanyAffiliated () {
      this.$store.dispatch('allAuth/getUserCompanyIds', this.formData).then(item => {
        this.paginations.company_ids = this.userCompanyIds
        this.$store.dispatch('adminCompany/getParentCompanies', this.paginations)
      })
    }
  },
  computed: {
    ...mapState({
      errorMessage: state => state.allAuth.errorMessage,
      user: state => state.allAuth.user,
      companies: state => state.adminCompany.companies,
      userCompanyIds: state => state.allAuth.userCompanyIds
    })
  },
  watch: {
    'formData.email' () {
      this.$store.commit('allAuth/CHANGE_PASSWORD_OR_EMAIL', '')
    },
    'formData.password' () {
      this.$store.commit('allAuth/CHANGE_PASSWORD_OR_EMAIL', '')
    }
  },
  created () {
    if (VueCookies.get('token')) {
      this.$store.dispatch('allAuth/getLoadProfile')
    }
  }
}
</script>
<style scoped lang='scss'>
  @import '@/assets/stylesheet/auth/login.scss';
</style>



// WEBPACK FOOTER //
// src/views/Login/Login.vue